// Centralized brand constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_abibe-wordpress/artifacts/d0qrf9a6_d56722d6-5d97-4f5c-9d07-000531c2ad52.png";
export const LOGO_ALT_URL = "https://customer-assets.emergentagent.com/job_abibe-wordpress/artifacts/dw32yd1y_Abide%20Daily.jpg";
export const SUBSCRIBE_BADGE = "https://customer-assets.emergentagent.com/job_abibe-wordpress/artifacts/wnwju2n6_subs.png";

export const MINISTRY = {
  name: "Abide Daily Ministry",
  tagline: "Helping You Abide in Christ Every Day",
  email: "abidedailyministry@gmail.com",
  youtube: "https://youtube.com/@abidedailyministry",
  youtubeHandle: "@abidedailyministry",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/devotionals", label: "Devotionals" },
  { to: "/bible-studies", label: "Bible Studies" },
  { to: "/bible-promises", label: "Bible Promises" },
  { to: "/videos", label: "Videos" },
  { to: "/prayer-requests", label: "Prayer Requests" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];
